"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var SparkIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || '18', height: size || '18' }, props),
        React.createElement("path", { fill: "currentColor", d: "M6.382 6.22L8.615.266a.411.411 0 0 1 .77 0l2.232 5.952a.277.277 0 0 0 .163.163l5.952 2.233a.411.411 0 0 1 0 .77l-5.952 2.232a.285.285 0 0 0-.163.163l-2.233 5.952a.41.41 0 0 1-.77 0L6.383 11.78a.289.289 0 0 0-.163-.163L.267 9.386a.412.412 0 0 1 0-.771l5.952-2.233a.281.281 0 0 0 .163-.163", fillRule: "evenodd" })));
};
SparkIcon.displayName = 'SparkIcon';
exports.default = SparkIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SparkIcon.js.map